import { useFetchItems } from 'pe-core-frontend';
import { EXPORTS } from '../graphql/queries/export';
/**
 * Custom hook for fetching and managing imports.
 *
 * @param {UseExportsProps} options - The options for the hook.
 * @param {string} options.clientId - The client ID.
 * @returns {Object} - The import items, error, and loading state.
 */
export const useExports = ({ clientId, id }) => {
    const { items, error, loading, refetch } = useFetchItems({
        fetchQuery: EXPORTS,
        dataProp: 'exports',
        spec: { clientId, id },
    });
    return {
        items,
        error,
        loading,
        refetch,
    };
};
